import { SipPhoneIcon } from "@invosys/invosys-ui/icons";
import {
  AccountCircle,
  Assessment,
  Call,
  ContactPhone,
  Description,
  Dialpad,
  Domain,
  Equalizer,
  FilterDrama,
  LiveHelp,
  Money,
  People,
  PermMedia,
  PieChart,
  Web,
} from "@material-ui/icons";

export const iconMap = {
  Services: Call,
  Accounts: AccountCircle,
  Users: People,
  Numbers: Dialpad,
  Contacts: ContactPhone,
  "Report Hub": Equalizer,
  Reports: PieChart,
  Reporting: PieChart,
  "Live Stats": Assessment,
  Wallboard: Web,
  Media: PermMedia,
  Statement: Description,
  "SIP Trunks": SipPhoneIcon,
  Hosted: FilterDrama,
  "Help & Support": LiveHelp,
  Billing: Money,
  Sites: Domain,
};

export default iconMap;
